import { render, staticRenderFns } from "./MatchSignupConfigDetail.vue?vue&type=template&id=2843827b&"
import script from "./MatchSignupConfigDetail.vue?vue&type=script&lang=js&"
export * from "./MatchSignupConfigDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports